module.exports = __webpack_public_path__ + "9731b5103dd0d730d368b239af00bbc3.fbx";